<template>
  <div class="base-card-wrapper">
    <div class="base-card-heading-wrapper" v-if="heading || icon">
      <div class="round-button-array-wrapper">
        <round-button-with-icon
          v-for="(icon, index) in icons"
          :key="index"
          :icon="icon"
          @click="iconClicked(icon)"
          class="icon"
        />
      </div>
      <h3>{{ heading }}</h3>
      <div class="search-container" v-if="searchEnabled">
        <!-- todo : add transition -->
        <Input
          placeholder="Search for tracks..."
          @scs-input="search"
          @scs-blur="toggleSearch"
          v-if="searchActive"
        />
        <round-button-with-icon
          icon="search"
          class="icon"
          @click="toggleSearch"
        />
      </div>
    </div>
    <div
      :class="scrollable ? 'base-card-scroll-window base-card' : 'base-card'"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
import Input from "../Elements/Input.vue";
import RoundButtonWithIcon from "./RoundButtonWithIcon.vue";
export default {
  data() {
    return {
      searchActive: false,
    };
  },
  computed: {},
  methods: {
    iconClicked(icon) {
      this.$emit("icon-clicked", icon);
    },
    search(value) {
      this.$emit("search", value);
    },
    toggleSearch() {
      this.searchActive = !this.searchActive;
    },
  },
  created() {},
  components: { RoundButtonWithIcon, Input },
  props: ["heading", "icons", "searchEnabled", "scrollable"],
  emits: ["icon-clicked", "search"],
};
</script>
<style scoped>
@media screen {
  .base-card-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .base-card-heading-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  h3 {
    margin-right: 15px;
  }
  .base-card {
    border-radius: 20px;
    padding: 30px;
    width: 100%;
    height: 100%;
    flex: 1;
    box-sizing: border-box;
    background-color: var(--secondaryColor);
    box-shadow: 0px 2px 4px var(--secondaryColor);
  }

  .base-card-scroll-window {
    max-height: 100%;
    overflow-y: scroll;
  }

  .round-button-array-wrapper {
    display: flex;
  }

  .icon {
    margin: 10px;
  }

  .search-container {
    display: flex;
    align-items: center;
    justify-self: flex-end;
    margin-left: auto;
    margin-right: 25px;
  }

  @media (min-width: 800px) {
    .base-card {
      padding: 30px;
      width: unset;
    }
  }
  @media (min-width: 1200px) {
    .base-card {
      width: calc(100% - 20px);
      /* margin-left: 20px; */
      align-self: flex-end;
      padding: 30px;
    }
  }
}
</style>
